import axios from "axios";
import {
	CREATE_ORDER,
	INIT_ORDER,
	IS_LOADING,
	LOAD_ORDER,
	ORDER_FAILED,
	UPDATE_ORDER,
} from "./actionTypes";

export const createOrder = (listdata) => (dispatch) => {
	console.log("createOrder data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	dispatch({ type: IS_LOADING });

	axios
		.post(listdata.url, listdata.data, config)
		.then((response) => {
			console.log("order response=", response);
			dispatch({
				type: CREATE_ORDER,
				payload: response.data,
			});
		})
		.catch((error) => {
			console.log("order error=", error);
			dispatch({
				type: ORDER_FAILED,
			});
		});
};
export const updateOrder = (listdata) => (dispatch) => {
	dispatch({ type: IS_LOADING });
	console.log("createOrder data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, listdata.data, config)
		.then((response) => {
			console.log("response=", response);
			dispatch({
				type: UPDATE_ORDER,
				payload: response.data,
			});
		})
		.catch((error) => {
			console.log("order error=", error);
			dispatch({
				type: ORDER_FAILED,
			});
		});
};

export const loadOrder = (listdata) => (dispatch) => {
	console.log("loadOrder data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};
	dispatch({ type: INIT_ORDER });

	axios.post(listdata.url, listdata.data, config).then((response) => {
		console.log("response=", response);
		dispatch({
			type: LOAD_ORDER,
			payload: response.data,
		});
	});
};
